"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
// @ts-ignore
var cjs_ponyfill_1 = require("abortcontroller-polyfill/dist/cjs-ponyfill");
var AbortManager_1 = require("./abortManager/AbortManager");
var makeAbortable_1 = __importStar(require("./abortManager/makeAbortable"));
var CallManager = /** @class */ (function () {
    function CallManager() {
        this.abortManager = new AbortManager_1.AbortManager();
    }
    CallManager.prototype.exec = function (call, payload, options) {
        var _this = this;
        var tags = options.tags;
        tags = tags === undefined ? [] : tags;
        tags = Array.isArray(tags) ? tags : [tags];
        var controller = typeof AbortController !== 'undefined' ? new AbortController() : new cjs_ponyfill_1.AbortController();
        var signal = controller.signal;
        var request = call(payload, __assign(__assign({}, options), { signal: signal, tags: tags }));
        tags.push(payload);
        tags.push(request);
        return (0, makeAbortable_1.default)(this.abortManager.registerAbortable(request, controller, tags), function () { return _this.abort(payload); });
    };
    CallManager.prototype.abort = function (tags) {
        this.abortManager.abort(tags);
    };
    CallManager.isAbortError = function (error) {
        return CallManager.isAbortControllerError(error) || (0, makeAbortable_1.isPromiseAbortError)(error);
    };
    CallManager.isAbortControllerError = function (error) {
        // @ts-ignore
        return (error === null || error === void 0 ? void 0 : error.name) === 'AbortError' || (error === null || error === void 0 ? void 0 : error.code) === 20;
    };
    CallManager.isBrowserAbortError = function (error) {
        return (error === null || error === void 0 ? void 0 : error.name) === 'BrowserAbortError';
    };
    return CallManager;
}());
exports.default = CallManager;
//# sourceMappingURL=CallManager.js.map